import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import useSelectedPaymentMethod from 'hooks/useSelectedPaymentMethod';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { useParkingStore } from 'stores/parkingStore';
import styled from 'styled-components/native';
import { Pill } from 'styles/CommonLayoutStyles';
import { getPaymentMethodInfo, isCard } from 'utils/paymentUtils';
import { useUiStore } from 'stores/uiStore';

const Container = styled.View`
  flex-direction: row;
  align-items: center;
`;

const IconWrapper = styled.View`
  margin-right: 4px;
`;

const TextWrapper = styled.View`
  margin-right: 28px;
`;

const PaymentCardSelector = () => {
  const selectedPaymentMethod = useSelectedPaymentMethod();
  const { t } = useTranslation();
  const handleOnPress = () => {
    useUiStore.getState().setSheetModal('parkingPaymentMethod');
  };
  const { parkingConditions } = useParkingStore((state) => state);
  const { parkingZoneCountryCode } = parkingConditions ?? {};

  const isCreditCard = isCard(selectedPaymentMethod);

  const { text: paymentMethodText, icon: paymentMethodIcon } =
    getPaymentMethodInfo(
      isCreditCard,
      selectedPaymentMethod,
      parkingZoneCountryCode,
      t
    );

  const type = isCreditCard ? selectedPaymentMethod.lastNums : 'billing';
  return (
    <Pill bg={theme.colors.gray50}>
      <TouchableOpacity onPress={handleOnPress} testID="credit-card-touchable">
        <Container>
          <IconWrapper>
            {selectedPaymentMethod ? (
              <Icon
                testID={`credit-card-icon-${type}`}
                name={`${paymentMethodIcon}`}
                color={isCreditCard ? undefined : theme.colors.boost.green}
                size="l"
              />
            ) : (
              <Icon
                testID="Credit_Card-Outlined"
                name="Credit_Card-Outlined"
                size="m"
              />
            )}
          </IconWrapper>
          <TextWrapper>
            <Meta testID="card-text">{paymentMethodText}</Meta>
          </TextWrapper>
          <Icon name="Chevron_Right" testID="dropdown-chevron" size="s" />
        </Container>
      </TouchableOpacity>
    </Pill>
  );
};

export default PaymentCardSelector;
